import { useState } from 'react';
import { Button, Heading, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import {
  FormContentContainer,
  FormFooterContainer,
  FormMainContainer,
} from '@duke-hq/ui/components/Modals/FormModalLayouts';
import { EmployerCoursesToggleList } from '../../components/EmployerCoursesToggleList';
import { testIds } from '../../testIds';

export function CoursesEditForm({
  initialCourseIds,
  onSave,
  onCancel,
  isSaving,
}: {
  initialCourseIds: string[];
  onSave: (courseIds: string[]) => void;
  onCancel: () => void;
  isSaving: boolean;
}): React.ReactElement {
  const [selected, setSelected] = useState<Set<string>>(() => new Set(initialCourseIds));

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        onSave([...selected]);
      }}
      style={{ width: '100%', height: '100%' }}
    >
      <FormMainContainer>
        <FormContentContainer>
          <VStack align="stretch" spacing={3} w="full">
            <Heading fontSize="lg" size="xs" w="full">
              <Trans>Edit suitable courses</Trans>
            </Heading>

            <EmployerCoursesToggleList selectedIds={selected} onChange={setSelected} />
          </VStack>
        </FormContentContainer>

        <FormFooterContainer>
          <Button
            type="submit"
            variant="primary"
            isLoading={isSaving}
            data-testid={testIds.saveEmployerButton}
          >
            <Trans>Save</Trans>
          </Button>
          <Button variant="secondary" onClick={onCancel} isDisabled={isSaving}>
            <Trans>Cancel</Trans>
          </Button>
        </FormFooterContainer>
      </FormMainContainer>
    </form>
  );
}
